import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { toast } from 'react-toastify';
import config from '../../config/config';
import { useAuth } from '../login/AuthContext';

const DeleteFileDialog = ({ dokumanId, onSuccess }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { userData, token} = useAuth();

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDeleteFile = async () => {
    setLoading(true);
    try {
      // API'ye silme isteği gönder
      const response = await fetch(`${config.baseURL}/musteriler/delete-file/${dokumanId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      const data = await response.text();

      if (!response.ok) {
        throw new Error(data || 'Dosya silinirken bir hata oluştu');
      }

      // Başarılı silme işlemi sonrası
      toast.success("Dosya başarıyla silindi");

      // Dialog'u kapat
      handleClose();

      // Eğer bir başarı callback'i varsa çağır (listeyi yenilemek için)
      if (onSuccess && typeof onSuccess === 'function') {
        onSuccess();
      }
    } catch (error) {
      console.error("Dosya silme hatası:", error);
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <IconButton
        color="error"
        onClick={handleOpen}
        size="small"
      >
        <DeleteIcon />
      </IconButton>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
      >
        <DialogTitle id="delete-dialog-title">
          Dosya Silme
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="delete-dialog-description">
            Bu dosyayı silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" disabled={loading}>
            İptal
          </Button>
          <Button
            onClick={handleDeleteFile}
            color="error"
            disabled={loading}
            autoFocus
          >
            {loading ? 'Siliniyor...' : 'Sil'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeleteFileDialog;